import React, { useEffect, useState } from "react";
import {
    Col,
    Row,
    Button,
    Form,
    CardHeader,
    CardBody,
    Card,
    CardFooter,
} from "reactstrap";
import { Formik } from "formik";
import { getInputs } from "../../EngineerReport.model";
import {
    FileStatus,
    FuelTypes,
    PortConstant,
    OperationPrecedence,
    VesselTypeConstant,
    AddInfoConstant,
} from "../../../../shared/constants";
import * as Yup from "yup";
import { useQuery } from "react-query";
import { queryKeyes } from "shared/queryKeys";
import { Get } from "VesselMaster/vesselMaster.hooks";
import apiGlobal, { apiMedia } from "global/api.global";
import ReportDetailsHeader from "Components/ReportDetailsHeader";
import ErrorComponent from "Components/ErrorComponent";
import FormValuesDebug from "utils/debugTools/FormValuesDebug";
import { queryClient } from "../../../../react-query/queryClient";
import { commonValidationMessages } from 'Components/ValidationErrorMessages';
import { checkForNaN, checkValidArray, checkValidObject, handleServerResponse, isFormUnchanged, loadArraySum, saveEditForm, useSafeFormikContext } from 'GenericForms/Helper';
import env from 'environment_system/env_system';
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "index";
import AlertPopup from "Alerts/AlertPopup";
import { useDocumentTitle } from "Components/useDocument.hooks";
import SteamDumpDetailsComponent from "./SteamDumpDetailsComponent";
import ShoreSupplyComponent from "./ShoreSupplyComponent";
import FuelConsumption from "./FuelConsumption";
import LNGCargoROB from "./LNGCargoROBComponent";
import FuelConsumptionBatchComponent from "./FuelConsumptionBatchComponent";
import { getCurrentReportAction, getCurrentReportFilesAction } from "Store/Generic/ReportingSlice";
import LoadingSkeletonForm from "Components/LoadingPopUp";
import { useEditReport } from "VesselReportingInfo/EditCompletedReports/EditReportProvider";
interface FuelConsumptionComponentType {
    toggleDynamicTabs?: any;
    setErrorMessage?: any,
}

const FuelConsumptionComponent = ({
    toggleDynamicTabs,
    setErrorMessage,
}: FuelConsumptionComponentType) => {
    const { editReportBool, setPreviousTabIndex, previousEnggTabIndex } = useEditReport();
    /** State for the form */
    useDocumentTitle("Fuel Consumption & ROB Report  - ecoSAIL");
    const { VesselID, ReportID, VoyageID, CurrentVessel, CurrentReport, PreviousReport, reportingLoading, ConfigurationLimits, reportingError } = useSelector((state: RootState) => state.Reporting);
    const dispatch = useDispatch();
    const bunkeringCurrentReport = CurrentReport?.data?.chief_engineer?.bunkering ?? null;
    const debunkeringCurrentReport = CurrentReport?.data?.chief_engineer?.fuel_debunkering ?? null;
    const fuelConsumptionCurrentReport = CurrentReport?.data?.chief_engineer?.fuel_consumption ?? null;
    const fuelBatchConsumptionCurrentReport = CurrentReport?.data?.chief_engineer?.fuel_consumption_batch ?? null;
    const shoreSupplyCurrentReport = CurrentReport?.data?.chief_engineer?.shore_supply ?? null;
    // const scrubingUnitCurrentReport = CurrentReport?.data?.chief_engineer?.reporting_scrubing_units_detail ?? null;
    const steamDumpDetailsCurrentReport = CurrentReport?.data?.chief_engineer?.steam_dump_detail ?? null;
    const lngCargoROBCurrentReport = CurrentReport?.data?.chief_engineer?.lng_cargo_rob ?? null;
    const cargoDetailsCurrentReport = CurrentReport?.data?.deck_officer?.cargo_detail ?? null;
    const lngCargoROBPreviousReport = PreviousReport?.data?.chief_engineer?.lng_cargo_rob ?? null;
    const fuelBatchROBPreviousReport = PreviousReport?.data?.chief_engineer?.report_batch_rob ?? [];
    const currentVesselReport = CurrentReport?.data?.vessel_reporting_information ?? null;
    let { Fuel_Consumption_inputs } = getInputs("fuel_consumption");
    const [measurementMethod, setMeasurementMethod] = useState<string>("Flow meter");
    const [adjustmentPopup, setAdjustmentPopup] = useState(false);
    const [count, setCount] = useState(0);
    const [fuelBatchIndex, setFuelBatchIndex] = useState<any>(null);
    const [finalBatchConsumptionArray, setFinalBatchConsumptionArray] = useState<Array<any>>([]);
    const [totalLNGBunkerROB, setTotalLNGBunkerROB] = useState(0);
    const [EDNFiles, setEDNFiles] = useState<any>([]);
    const [refreshKey, setRefreshKey] = useState<number>(0)
    const [alertBool, setAlertBool] = useState<boolean>(false);
    const [alertMessage, setAlertMessage] = useState(null);
    const [alertColourType, setAlertColourType] = useState<any>(null);
    const [alertType, setAlertType] = useState<string>(null);
    const [addOtherPort, setAddOtherPort] = useState(false);
    const [otherPort, setOtherPort] = useState(false);
    const isShoreSupply =
        currentVesselReport &&
        (
            currentVesselReport.reporting_operation_mode === OperationPrecedence.ANCHOR_STAY ||
            currentVesselReport.reporting_operation_mode === OperationPrecedence.PORT_STAY
        );
    const formikContext = useSafeFormikContext<any>();
    const editValues = formikContext?.values;
    const setEditValues = formikContext?.setValues;
    const editInitialValues = formikContext?.initialValues;
    const editSubmit = formikContext?.submitForm;
    const editIsSubmitting = formikContext?.isSubmitting;
    const { VesselState } = useSelector((state: RootState) => state.Reporting);
    const [refreshEDN, setRefreshEDN] = useState(0);
    const fuelTypes = ConfigurationLimits?.vessel_fuel_information || [];
    const fuelSettings = ConfigurationLimits?.vessel_fuel_setting || [];
    const machineryFuelGroup = ConfigurationLimits?.vessel_machinery_fc_group || [];
    const isSteamDump = ConfigurationLimits?.is_steam_dump_valve_in_use
    /** End State */

    /** Queries */
    /** Fetch fuel Batch Bunkering */
    const {
        data: fuelBatches,
        isLoading: fuelBatchesLoading,
        isError: fuelBatchesError,
        isFetching: fuelBatchesFetching,
    } = useQuery(
        [queryKeyes.vessel.BunkeringByVessel.key, VesselID, ReportID],
        async () => {
            return await Get(queryKeyes.vessel.BunkeringByVessel.url(VesselID, ReportID), VesselID, ReportID);
        },
        {
            staleTime: 0
        }
    );
    /** Additional details object used for edit */
    const {
        data: AdditionalDetailsObject,
        isLoading: AdditionalDetailsObjectLoading,
    } = useQuery(
        [queryKeyes.vessel.ProactiveAddDetailsObject.key, VesselID, ReportID],
        async () => {
            return await Get(queryKeyes.vessel.ProactiveAddDetailsObject.url(VesselID, ReportID), VesselID, ReportID);
        },
        {
            staleTime: Infinity,
            enabled: env?.additional_info_engg === AddInfoConstant.PROACTIVE_ENGG
        }
    )
    /** Other ports object used for edit */
    const {
        data: OtherPortsObject,
        isLoading: OtherPortsLoading,
    }: { data: any; isLoading: any; isError: any } = useQuery(
        [queryKeyes.masters.OtherPortMaster.key, VesselID, ReportID],
        async () => {
            return await Get(queryKeyes.masters.OtherPortMaster.url());
        },
        {
            enabled: isShoreSupply ?? false,
            staleTime: Infinity
        }
    );
    /** End Queries */

    /** Enable/disable fields based on machine-fuel applicability */
    const machineryEnabled = (machine: number, fuel: number) => {
        if (fuelSettings?.filter((item: any) => item.vessel_machinery_fc_group === machine &&
            item.fuel_type === fuel &&
            item.vessel === VesselID)[0]?.selected === true) {
            return false;
        }
        return true;
    };

    /** Assign initial values to fuel consumptiom formik object */
    const getFuelInitialValues = () => {
        let newFuelConsumption: any[] = [];
        if (checkValidArray(editInitialValues?.chief_engineer?.fuel_consumption)) {
            return editInitialValues?.chief_engineer?.fuel_consumption;
        }
        if (checkValidArray(fuelConsumptionCurrentReport)) {
            return fuelConsumptionCurrentReport;
        } else if (
            newFuelConsumption !== undefined &&
            machineryFuelGroup !== undefined &&
            fuelTypes !== undefined &&
            newFuelConsumption.length <= machineryFuelGroup.length * fuelTypes.length
        ) {
            machineryFuelGroup.flatMap((machine: any) => {
                fuelTypes.map((fuel: any) => {
                    newFuelConsumption.push({
                        vessel: VesselID,
                        vessel_machinery_fc_group: machine.id,
                        sub_type_precedence_id: fuel?.precedence_id_sub_type,
                        machinery_precedence_id: machine?.machinery_precedence_id,
                        fuel_type_precedence_id: fuel?.fuel_type_precedence_id,
                        fuel_type: fuel.fuel_type,
                        method_used_to_measure_fuel_oil_consumption: "Flow meter",
                        fuel_consumed: machineryEnabled(machine?.id, fuel?.fuel_type) ? 0 : null,
                        voyage_information: VoyageID,
                        vessel_reporting_information: ReportID,
                    });
                    return fuel;
                });
                return machine;
            });
            return newFuelConsumption;
        } else {
            return (newFuelConsumption = [
                {
                    fuel_consumed: 0,
                    vessel_machinery_fc_group: 0,
                    fuel_type: 0,
                    method_used_to_measure_fuel_oil_consumption: "Flow meter",
                    vessel: VesselID,
                    voyage_information: VoyageID,
                    vessel_reporting_information: ReportID,
                },
            ]);
        }
    };
    /** Assign initial values to batch consumptiom formik object */
    const getFuelBatchInitialValues = () => {
        let newFuelBatchConsumption: any[] = [];
        if (checkValidArray(editInitialValues?.chief_engineer?.fuel_consumption_batch)) {
            newFuelBatchConsumption.push(...editInitialValues?.chief_engineer?.fuel_consumption_batch.sort((a: any, b: any) => a.id - b.id));
            return newFuelBatchConsumption;
        }
        if (checkValidArray(fuelBatchConsumptionCurrentReport)) {
            newFuelBatchConsumption.push(...fuelBatchConsumptionCurrentReport);
            fuelBatches?.forEach((batch: any) => {
                if (!fuelBatchConsumptionCurrentReport.some((item: any) => item.bunkering === batch.id)) {
                    newFuelBatchConsumption.sort((a: any, b: any) => a.id - b.id).push({
                        fuel_consumption: null,
                        viscosity: 0,
                        rob: 0,
                        previous_rob: 0,
                        adjustment_quantity: 0,
                        fuel_type_precedence_id: batch?.fuel_type_precedence_id,
                        adjustment_reason: null as string,
                        fuel_type: batch?.fuel_type,
                        fuel_sub_type: batch?.fuel_sub_type,
                        bunkering: batch?.id,
                        vessel: VesselID,
                        voyage_information: VoyageID,
                        vessel_reporting_information: ReportID,
                    });
                }
            });
            return newFuelBatchConsumption;
        } else if (
            fuelBatches !== undefined &&
            newFuelBatchConsumption.length <= fuelBatches.length
        ) {
            fuelBatches?.sort((a: any, b: any) => a.id - b.id)?.filter((item: any) => item.status === "inuse")
                .map((batch: any) => {
                    newFuelBatchConsumption.push({
                        fuel_consumption: null,
                        viscosity: 0,
                        rob: 0,
                        previous_rob: 0,
                        adjustment_quantity: 0,
                        fuel_type_precedence_id: batch?.fuel_type_precedence_id,
                        adjustment_reason: null as string,
                        fuel_type: batch?.fuel_type,
                        fuel_sub_type: batch?.fuel_sub_type,
                        bunkering: batch?.id,
                        vessel: VesselID,
                        voyage_information: VoyageID,
                        vessel_reporting_information: ReportID,
                    });
                    return batch;
                });
            return newFuelBatchConsumption;
        } else {
            return (newFuelBatchConsumption = [
                {
                    fuel_consumption: 0,
                    viscosity: 0,
                    rob: 0,
                    previous_rob: 0,
                    fuel_type: 0,
                    bunkering: 0,
                    vessel: VesselID,
                    voyage_information: VoyageID,
                    vessel_reporting_information: ReportID,
                },
            ]);
        }
    };
    /** Assign initial values to shore supply formik object */
    const getShoreSupplyInitialValues = () => {
        if (editInitialValues && editInitialValues?.chief_engineer?.shore_supply) {
            return editInitialValues?.chief_engineer?.shore_supply;
        }
        if (checkValidObject(shoreSupplyCurrentReport) && !editReportBool) {
            return shoreSupplyCurrentReport;
        } else {
            return ({
                is_edn_issue: false,
                total_kw_used: null,
                total_time: null,
                co2_equivalent: null,
                edn_file_uploads: null,
                is_shore_supply_used: false,
                port: null,
                port_country_name: null as string,
                other_port: null as number,
                other_port_name: null as string,
                other_country: null as number,
                time_on_shore_supply: null as number,
                quantity_of_shore_supply: null as number,
                vessel: VesselID,
                voyage_information: VoyageID,
                vessel_reporting_information: ReportID,
            });
        }
    };
    /** Assign values to initial object of Srubing units */
    // const getScrubingInitialValues = () => {
    //     if (editInitialValues && editInitialValues?.chief_engineer?.reporting_scrubing_units_detail?.id > 0) {
    //         return editInitialValues?.chief_engineer?.reporting_scrubing_units_detail;
    //     }
    //     if (checkValidArray(scrubingUnitCurrentReport)) {
    //         return scrubingUnitCurrentReport;
    //     } else {
    //         return {
    //             is_egcs_in_use: false,
    //             is_scr_in_use: false,
    //             is_egr_in_use: false,
    //             vessel: VesselID,
    //             voyage_information: VoyageID,
    //             vessel_reporting_information: ReportID,
    //         };
    //     }
    // };

    /** Assign initial values to batch consumptiom formik object */
    const getLNGCargoROBInitialValues = () => {
        if (editInitialValues && editInitialValues?.chief_engineer?.lng_cargo_rob?.length > 0) {
            return editInitialValues?.chief_engineer?.lng_cargo_rob;
        }
        if (CurrentVessel?.vessel_type_precedence_id === VesselTypeConstant.LNG_CARRIER) {
            if (checkValidObject(lngCargoROBCurrentReport) && checkValidObject(cargoDetailsCurrentReport)) {
                // Return current report with updated cargo adjusted from cargo details
                const cloned = {
                    ...lngCargoROBCurrentReport,
                    cargo_adjusted: cargoDetailsCurrentReport?.cargo_adjusted,
                };
                return cloned;
            } else {
                return {
                    initial_rob: 0,
                    lng_initial_cargo_rob: null,
                    cargo_consumed: 0,
                    cargo_rob: (checkValidObject(lngCargoROBPreviousReport)) ?
                        lngCargoROBPreviousReport?.cargo_rob ?? 0 :
                        cargoDetailsCurrentReport?.total_amount_of_cargo_onboard + cargoDetailsCurrentReport?.cargo_used,
                    cargo_adjusted: cargoDetailsCurrentReport?.cargo_adjusted ?? 0,
                    cargo_loaded_cargo_detail: (checkValidObject(cargoDetailsCurrentReport)) ? cargoDetailsCurrentReport?.id : null,
                    cargo_discharge_cargo_detail: (checkValidObject(cargoDetailsCurrentReport)) ? cargoDetailsCurrentReport?.id : null,
                    vessel: VesselID,
                    voyage_information: VoyageID,
                    vessel_reporting_information: ReportID,
                };
            }
        }
    };

    /** Assign initial values to steam details formik object */
    const getInitialSteamDumpValues = () => {
        if (checkValidObject(editInitialValues?.chief_engineer?.steam_dump_detail)) {
            return editInitialValues?.chief_engineer?.steam_dump_detail;
        }
        if (checkValidObject(steamDumpDetailsCurrentReport)) {
            return steamDumpDetailsCurrentReport;
        } else {
            return {
                steam_dump_valve_percentage: null as number,
                vessel: VesselID,
                voyage_information: VoyageID,
                vessel_reporting_information: ReportID,
            };
        }
    };

    /** Assign initial values to measurement method */
    useEffect(() => {
        if (checkValidArray(fuelConsumptionCurrentReport)) {
            const method = fuelConsumptionCurrentReport[0]?.method_used_to_measure_fuel_oil_consumption;
            if (method) setMeasurementMethod(method);
        } else if (checkValidArray(editInitialValues?.chief_engineer?.fuel_consumption)) {
            const method = editInitialValues?.chief_engineer?.fuel_consumption?.[0]?.method_used_to_measure_fuel_oil_consumption;
            if (method) setMeasurementMethod(method);
        }
    }, [fuelConsumptionCurrentReport, editInitialValues]);

    useEffect(() => {
        if (!isShoreSupply) return;

        if (editReportBool) {
            // use editValues
            if (checkValidObject(editValues?.chief_engineer?.shore_supply)) {
                const shoreSupply = editValues?.chief_engineer?.shore_supply;
                if (shoreSupply?.port_country_name === 'Other-Other' && !addOtherPort) {
                    setOtherPort(true);
                }
            }
        } else {
            // use current report
            if (checkValidObject(shoreSupplyCurrentReport)) {
                if (
                    shoreSupplyCurrentReport?.port_precedence_id === PortConstant.OTHER && !addOtherPort
                ) {
                    setOtherPort(true);
                }
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isShoreSupply, editReportBool, shoreSupplyCurrentReport, editValues?.chief_engineer?.shore_supply?.port_country_name]);

    /** useEffect */
    useEffect(() => {
        FuelConsumptionFormik.initialValues.fuelConsumption =
            getFuelInitialValues();
        setRefreshKey(refreshKey + 1);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [fuelConsumptionCurrentReport, machineryFuelGroup, fuelTypes]);
    useEffect(() => {
        FuelConsumptionFormik.initialValues.fuelConsumptionBatch =
            getFuelBatchInitialValues();
        setRefreshKey(refreshKey + 1);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [fuelBatchConsumptionCurrentReport, fuelBatches]);
    useEffect(() => {
        FuelConsumptionFormik.initialValues.shoreSupply =
            getShoreSupplyInitialValues();
        setRefreshKey(refreshKey + 1);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [shoreSupplyCurrentReport]);
    useEffect(() => {
        FuelConsumptionFormik.initialValues.lngCargoROB =
            getLNGCargoROBInitialValues();
        setRefreshKey(refreshKey + 1);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [lngCargoROBPreviousReport, lngCargoROBCurrentReport, cargoDetailsCurrentReport]);
    useEffect(() => {
        FuelConsumptionFormik.initialValues.steamDumpDetails =
            getInitialSteamDumpValues();
        setRefreshKey(refreshKey + 1);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isSteamDump, steamDumpDetailsCurrentReport]);
    useEffect(() => {
        const withLNGBunker: any[] = fuelBatches?.filter(
            (item: any) => item.fuel_type_precedence_id === FuelTypes.LNG_BUNKER
        );
        const withoutLNGBunker: any[] = fuelBatches?.filter(
            (item: any) => item.fuel_type_precedence_id !== FuelTypes.LNG_BUNKER
        );
        let finalArray: any[] = [];
        withoutLNGBunker?.forEach((without: any) => {
            finalArray.push(without);
        });
        if (withLNGBunker?.length > 0) {
            finalArray.push(withLNGBunker[0]);
        }
        setFinalBatchConsumptionArray(finalArray);
    }, [fuelBatches]);
    useEffect(() => {
        setTotalLNGBunkerROB(
            fuelBatches
                ?.filter(
                    (item: any) => item.fuel_type_precedence_id === FuelTypes.LNG_BUNKER
                )
                ?.reduce(
                    (sum: number, item: any) => sum + (item.quantity_remaining || 0),
                    0
                )
        );
    }, [fuelBatches, debunkeringCurrentReport]);
    /** useEffect end */

    /** Fuel Consumption Formik object */
    let FuelConsumptionFormik = {
        initialValues: {
            // scrubingUnit: getScrubingInitialValues(),
            shoreSupply: getShoreSupplyInitialValues(),
            fuelConsumption: getFuelInitialValues(),
            fuelConsumptionBatch: getFuelBatchInitialValues(),
            lngCargoROB: getLNGCargoROBInitialValues(),
            steamDumpDetails: getInitialSteamDumpValues(),
        },
        validationSchema: Yup.object().shape({
            // egcs_in_use: Yup.boolean(),
            // scr_in_use: Yup.boolean(),
            // egr_in_use: Yup.boolean(),
            shoreSupply: Yup.object({
                time_on_shore_supply: Yup.string()
                    .when('is_shore_supply_used', {
                        is: true,
                        then: (schema: any) => schema
                            .matches(/^(?:25(?:\.00?)?|0*(?:[0-1]?\d|2[0-4])(?:\.\d{1,2})?)$/, commonValidationMessages.max25)
                            .required(commonValidationMessages.required),
                        otherwise: (schema: any) => schema.nullable(),
                    }),
                quantity_of_shore_supply: Yup.string()
                    .when('is_shore_supply_used', {
                        is: true,
                        then: (schema: any) => schema
                            .matches(/^\d{0,5}(?:\.\d{1,4})?$/, commonValidationMessages.before5after4)
                            .required(commonValidationMessages.required),
                        otherwise: (schema: any) => schema.nullable(),
                    }),
                total_time: Yup.string()
                    .when('is_edn_issue', {
                        is: true,
                        then: (schema: any) => schema
                            .matches(/^\d{0,5}(?:\.\d{1,4})?$/, commonValidationMessages.before5after4)
                            .required(commonValidationMessages.required),
                        otherwise: (schema: any) => schema.nullable(),
                    })
                    .test(
                        'not-zero',
                        commonValidationMessages.min1,
                        function (value) {
                            const shoreSupplyObject = this.parent ? this.parent : {};
                            if (shoreSupplyObject?.is_edn_issue === true) {
                                if (value == null || value === '') return true;
                                return parseFloat(value) > 0;
                            }
                            return true;
                        }
                    ),
                total_kw_used: Yup.string()
                    .when('is_edn_issue', {
                        is: true,
                        then: (schema: any) => schema
                            .matches(/^\d{0,6}(?:\.\d{1,4})?$/, commonValidationMessages.before6after4)
                            .required(commonValidationMessages.required),
                        otherwise: (schema: any) => schema.nullable(),
                    })
                    .test(
                        'not-zero',
                        commonValidationMessages.min1,
                        function (value) {
                            const shoreSupplyObject = this.parent ? this.parent : {};
                            if (shoreSupplyObject?.is_edn_issue === true) {
                                if (value == null || value === '') return true;
                                return parseFloat(value) > 0;
                            }
                            return true;
                        }
                    ),
                co2_equivalent: Yup.string()
                    .when('is_edn_issue', {
                        is: true,
                        then: (schema: any) => schema
                            .matches(/^\d{0,5}(?:\.\d{1,4})?$/, `${commonValidationMessages.before5after4} (unit: mt)`)
                            .required(commonValidationMessages.required),
                        otherwise: (schema: any) => schema.nullable(),
                    })
                    .test(
                        'not-zero',
                        commonValidationMessages.min1,
                        function (value) {
                            const shoreSupplyObject = this.parent ? this.parent : {};
                            if (shoreSupplyObject?.is_edn_issue === true) {
                                if (value == null || value === '') return true;
                                return parseFloat(value) > 0;
                            }
                            return true;
                        }
                    ),
                port: Yup.number().when('is_shore_supply_used', {
                    is: true,
                    then: (schema) => schema.required(commonValidationMessages.required),
                    otherwise: (schema) => schema.nullable(),
                }),
                other_port: Yup.string().when('is_shore_supply_used', {
                    is: true,
                    then: (schema) => schema.when('$fieldAvailability', (field: any, schema) => {
                        return !(otherPort === true && OtherPortsObject)
                            ? schema.nullable()
                            : schema.required(commonValidationMessages.required);
                    }),
                    otherwise: (schema) => schema.nullable(),
                }),
                other_port_name: Yup.string().when('is_shore_supply_used', {
                    is: true,
                    then: (schema) => schema.when('$fieldAvailability', (field: any, schema) => {
                        return !(addOtherPort === true || !OtherPortsObject)
                            ? schema.nullable()
                            : schema.required(commonValidationMessages.required);
                    }),
                    otherwise: (schema) => schema.nullable(),
                }),
                other_country: Yup.number().when('is_shore_supply_used', {
                    is: true,
                    then: (schema) => schema.when('$fieldAvailability', (field: any, schema) => {
                        return !(addOtherPort === true || !OtherPortsObject)
                            ? schema.nullable()
                            : schema.required(commonValidationMessages.required);
                    }),
                    otherwise: (schema) => schema.nullable(),
                }),
            }),
            fuelConsumption: Yup.array(
                Yup.object({
                    fuel_consumed: Yup.string().matches(/^\d{0,7}(?:\.\d{1,4})?$/, commonValidationMessages.before7after4)
                        .required(commonValidationMessages.required),
                    vessel_machinery_fc_group: Yup.number(),
                    fuel_type: Yup.number(),
                    vessel: Yup.number(),
                    voyage_information: Yup.number(),
                    vessel_reporting_information: Yup.number(),
                })
            ),
            fuelConsumptionBatch: Yup.array(
                Yup.object({
                    fuel_consumption: Yup.string().matches(/^\d*\.?\d+$/, commonValidationMessages.validNumber).nullable(),
                    viscosity: Yup.number().nullable(),
                    rob: Yup.number(),
                    previous_rob: Yup.number(),
                    fuel_type: Yup.number(),
                    bunkering: Yup.number(),
                    adjustment_quantity: Yup.string()
                        .matches(
                            /^[+-]?\d{1,7}(?:\.\d{1,4})?$/,
                            commonValidationMessages.before7after4
                        )
                        .required(commonValidationMessages.required),
                    adjustment_reason: Yup.string().when('adjustment_quantity', (val: any, schema: any) => {
                        if (parseFloat(val) !== 0) {
                            return schema.max(200, commonValidationMessages.max200).required(commonValidationMessages.required);
                        }
                        return schema.nullable();
                    }),
                    vessel: Yup.number(),
                    voyage_information: Yup.number(),
                    vessel_reporting_information: Yup.number(),
                }).test(
                    "fuelConsumptionbatch",
                    "Total fuel batch consumption should be same as the total fuel consumption",
                    function (value: any) {
                        const values = this.options?.context;
                        const fuelConsumptionBatch: any = this.parent ? this.parent : [];
                        let index = fuelConsumptionBatch?.indexOf(value);
                        if (value.fuel_consumption === null) {
                            return new Yup.ValidationError(commonValidationMessages.required, undefined, `fuelConsumptionBatch.${index}.fuel_consumption`);
                        }
                        if (value.fuel_type_precedence_id !== FuelTypes.LNG_CARGO) {
                            const currentFuelType = value.fuel_type_precedence_id;
                            const currentBatch = value.bunkering;
                            const totalConsumptionForFuelType = parseFloat(values?.fuelConsumption
                                .filter((item: any) => item.fuel_type_precedence_id === currentFuelType)
                                .reduce((sum: number, item: any) => sum + (parseFloat(item.fuel_consumed ?? 0)), 0));
                            if (
                                currentFuelType !== FuelTypes.LNG_CARGO &&
                                currentFuelType !== FuelTypes.LNG_BUNKER
                            ) {
                                if ((checkValidArray(bunkeringCurrentReport) &&
                                    bunkeringCurrentReport?.some((bunker: any) => bunker.id === currentBatch)) === true) {
                                    const Batchrob = checkForNaN(bunkeringCurrentReport?.find((item: any) => item.id === currentBatch)?.quantity_bunkered);
                                    if (checkForNaN(
                                        (Batchrob -
                                            checkForNaN(debunkeringCurrentReport?.filter((item: any) =>
                                                item.bunkering === currentBatch)[0]?.quantity_debunkered) -
                                            checkForNaN(value.fuel_consumption) +
                                            checkForNaN(value.adjustment_quantity)
                                        ), 4) < 0
                                    ) {
                                        return new Yup.ValidationError(
                                            'The combined value of fuel consumption and adjustment quantity should be equal to or less than fuel batch ROB',
                                            null,
                                            `fuelConsumptionBatch.${index}.previous_rob`
                                        );
                                    }
                                } else if (checkForNaN(fuelBatchROBPreviousReport?.filter((item: any) => item.bunkering === currentBatch)[0]?.rob) > 0) {
                                    if (
                                        checkForNaN((checkForNaN(fuelBatchROBPreviousReport?.filter((item: any) => item.bunkering === currentBatch)[0]?.rob) -
                                            checkForNaN(debunkeringCurrentReport?.filter((item: any) => item.bunkering === currentBatch)[0]?.quantity_debunkered) -
                                            checkForNaN(value.fuel_consumption) +
                                            checkForNaN(value.adjustment_quantity)
                                        ), 4) < 0
                                    ) {
                                        return new Yup.ValidationError(
                                            'The combined value of fuel consumption and adjustment quantity should be equal to or less than fuel batch ROB',
                                            null,
                                            `fuelConsumptionBatch.${index}.previous_rob`
                                        );
                                    }
                                }
                                if (
                                    totalConsumptionForFuelType?.toFixed(4) !==
                                    loadArraySum(fuelConsumptionBatch, "fuel_type_precedence_id", "fuel_consumption")[currentFuelType]?.toFixed(4)
                                ) {
                                    return new Yup.ValidationError(
                                        `Total fuel batch consumption should be same as the total fuel consumption`,
                                        undefined,
                                        `finalBatchConsumptionArray.${index}`
                                    );
                                }
                            }
                            if (
                                currentFuelType === FuelTypes.LNG_BUNKER &&
                                totalLNGBunkerROB < value.fuel_consumption
                            ) {
                                return new Yup.ValidationError(
                                    `Fuel batch consumption should be equal to or less than fuel ROB`,
                                    undefined,
                                    `finalBatchConsumptionArray.${index}`
                                );
                            }
                            return true;
                        }
                        return true;
                    })
            ),
            steamDumpDetails: Yup.object({
                steam_dump_valve_percentage: Yup.string()
                    .matches(/^(100(\.0{1,2})?|([0-9]{1,2})(\.[0-9]{1,2})?|0(\.[0-9]{1,2})?)$/, commonValidationMessages.maxVal100)
                    .nullable(),
            }),
        }),
    };

    /** Assign values to viscosity, rob, previous_rob */
    const handleFuelBatchConsumptionChanges = (
        e: any,
        form: any,
        bunker: any,
        values: any,
        fuelconsumptionBatch: any,
        fuelbatch?: any,
    ) => {
        form.setFieldValue(
            `fuelConsumptionBatch.${values?.fuelConsumptionBatch.indexOf(
                fuelbatch
            )}.viscosity`,
            bunker.viscosity
        );
        if (fuelbatch?.fuel_type_precedence_id === FuelTypes.LNG_BUNKER) {
            let remainder: number = 0;
            values?.fuelConsumptionBatch
                .filter((item: any) => item.fuel_type_precedence_id === FuelTypes.LNG_BUNKER)
                .forEach((batch: any, index: number) => {
                    fuelBatches
                        .filter((item: any) => item.id === batch.bunkering)
                        .forEach((lngBunker: any) => {
                            batch.previous_rob = lngBunker.quantity_remaining;
                            if (!(parseFloat(e.target.value) > totalLNGBunkerROB)) {
                                if (
                                    lngBunker.quantity_remaining === e.target.value ||
                                    lngBunker.quantity_remaining > e.target.value
                                ) {
                                    if (index === 0) {
                                        batch.fuel_consumption = e.target.value;
                                        batch.rob = lngBunker.quantity_remaining - (parseFloat(e.target.value));
                                    } else {
                                        batch.fuel_consumption = 0;
                                        batch.rob = lngBunker.quantity_remaining;
                                    }
                                } else if (index === 0) {
                                    if (lngBunker.quantity_remaining < e.target.value) {
                                        batch.fuel_consumption = lngBunker.quantity_remaining;
                                        batch.rob = 0;
                                        remainder = (parseFloat(e.target.value)) - lngBunker.quantity_remaining;
                                    }
                                } else if (index > 0) {
                                    if (lngBunker.quantity_remaining < remainder) {
                                        batch.fuel_consumption = lngBunker.quantity_remaining;
                                        batch.rob = 0;
                                        remainder -= lngBunker.quantity_remaining;
                                    } else {
                                        batch.fuel_consumption = remainder;
                                        batch.rob = lngBunker.quantity_remaining - remainder;
                                    }
                                }
                            }
                        });
                });
        }
    };

    /** Fuel measurement method */
    const measurementMethodOptions: any[] = [
        { id: "1", label: "BDN" },
        { id: "2", label: "Flow meter" },
        { id: "3", label: "Bunkered fuel tank monitoring" },
        { id: "4", label: "none" },
    ];

    /** Open close modal */
    function removeBodyCss() {
        document.body.classList.add("no_padding");
    }

    function tog_backdrop() {
        setAdjustmentPopup(!adjustmentPopup);
        setFuelBatchIndex(null);
        removeBodyCss();
    }
    return (
        <Card className="p-0 mb-0 border-0">
            <CardHeader className="p-2">
                <div className="text-center">
                    <Row>
                        <Col>
                            <h4 className="page_title pos-start mb-0">
                                Fuel Consumption & ROB
                            </h4>
                            <p className="card-title-desc pos-start">
                                All readings since last report
                            </p>
                        </Col>
                        <Col>
                            <ReportDetailsHeader />
                        </Col>
                    </Row>
                </div>
            </CardHeader>
            {(
                fuelBatchesLoading ||
                AdditionalDetailsObjectLoading ||
                OtherPortsLoading ||
                reportingLoading
            ) && (<> <LoadingSkeletonForm
                layout={[
                    [100, 100, 100],
                    [100, 100, 100],
                    [100, 100, 100],
                    [100, 100, 100],
                    [100]]} />
            </>)}
            {(
                reportingError ||
                fuelBatchesError
            ) && <ErrorComponent message="Unable to load required data!" />
            }
            {!(
                fuelBatchesLoading ||
                AdditionalDetailsObjectLoading ||
                OtherPortsLoading ||
                reportingLoading
            ) &&
                !(
                    reportingError ||
                    fuelBatchesError
                ) &&
                <Formik
                    key={refreshKey}
                    onSubmit={async (values: any, actions: any) => {

                        if (
                            env?.form_validation === false ||
                            (isFormUnchanged(FuelConsumptionFormik.initialValues, values) && EDNFiles.length === 0)
                        ) {
                            setErrorMessage(null);
                            toggleDynamicTabs(previousEnggTabIndex + 1);
                            return;
                        }
                        actions.setSubmitting(true);
                        const responseArray: any[] = [];
                        //     /** Scrubing unit submit */
                        //     // if (ScrubingUnitObject && ScrubingUnitObject.length > 0) {
                        //     //     responseArray.push(apiGlobal.put(`/reporting_scrubing_units_detail/${values?.scrubingUnit?.id}/`, values?.scrubingUnit));
                        //     // } else {
                        //     //     responseArray.push(apiGlobal.post(`/reporting_scrubing_units_detail/`, values.scrubingUnit));
                        //     // }
                        try {
                            /** Shore supply submit */
                            if (currentVesselReport &&
                                (currentVesselReport?.reporting_operation_mode === OperationPrecedence.ANCHOR_STAY ||
                                    currentVesselReport?.reporting_operation_mode === OperationPrecedence.PORT_STAY)) {
                                if (checkValidObject(shoreSupplyCurrentReport) && values?.shoreSupply?.id > 0) {
                                    if (!values?.shoreSupply?.is_shore_supply_used) {
                                        responseArray.push(apiMedia.delete(`/shore_supply/${values?.shoreSupply?.id}/`));
                                    } else {
                                        const formData = new FormData();
                                        Object.keys(values.shoreSupply).forEach((item: any) => {
                                            if (
                                                values.shoreSupply[item] === null ||
                                                values.shoreSupply[item] === undefined ||
                                                item === "edn_file_uploads"
                                            ) return;

                                            formData.append(item, values.shoreSupply[item]);
                                        });
                                        if (EDNFiles && Array.isArray(EDNFiles) && EDNFiles.length > 0) {
                                            EDNFiles.forEach((image: any) => {
                                                if (image.file !== null && image.file !== undefined) {
                                                    formData.append("edn_file_uploads", image.file);
                                                }
                                            });
                                        } else {
                                            formData.set("edn_file_uploads", "");
                                        }
                                        formData.delete("status");
                                        responseArray.push(apiMedia.put(`/shore_supply/${values?.shoreSupply?.id}/`, formData));
                                    }
                                } else {
                                    if (values?.shoreSupply?.is_shore_supply_used) {
                                        values.shoreSupply.edn_file_uploads = EDNFiles[0];
                                        const formData = new FormData();
                                        Object.keys(values.shoreSupply).forEach((item: any) => {
                                            if ((values.shoreSupply[item] === null || undefined) || item === "edn_file_uploads") return;
                                            formData.append(item, values.shoreSupply[item]);
                                        });
                                        if (EDNFiles && Array.isArray(EDNFiles) && EDNFiles[0]?.file) {
                                            // formData.set("edn_file_uploads", EDNFiles[0].file);
                                            EDNFiles.forEach(image => {
                                                formData.append("edn_file_uploads", image.file);
                                            });
                                        } else {
                                            formData.set("edn_file_uploads", "");
                                        }
                                        formData.delete("status");
                                        responseArray.push(apiMedia.post(`/shore_supply/`, formData));
                                    }
                                }
                            }
                            /** Fuel consumption submit */
                            values.fuelConsumption.forEach((val: any) => {
                                val.method_used_to_measure_fuel_oil_consumption = measurementMethod;
                            });
                            responseArray.push(apiGlobal.post(`/fuel_consumption_data/`, values));
                            /** Batch consumption submit */
                            finalBatchConsumptionArray?.forEach((batch: any) => {
                                values?.fuelConsumptionBatch
                                    ?.filter((fuel: any) => fuel.bunkering === batch.id)
                                    ?.forEach((fuelbatch: any) => {
                                        fuelbatch.viscosity = batch.viscosity;
                                        if (fuelbatch.fuel_type_precedence_id === FuelTypes.LNG_BUNKER) {
                                            let remainder: number = 0;
                                            values?.fuelConsumptionBatch
                                                .filter((item: any) => item.fuel_type_precedence_id === FuelTypes.LNG_BUNKER)
                                                .forEach((batch: any, index: number) => {
                                                    fuelBatches
                                                        .filter((item: any) => item.id === batch.bunkering)
                                                        .forEach((lngBunker: any) => {
                                                            batch.previous_rob = lngBunker.quantity_remaining;
                                                            if (!(parseFloat(fuelbatch?.fuel_consumption) > totalLNGBunkerROB)) {
                                                                if (
                                                                    lngBunker.quantity_remaining === fuelbatch?.fuel_consumption ||
                                                                    lngBunker.quantity_remaining > fuelbatch?.fuel_consumption
                                                                ) {
                                                                    if (index === 0) {
                                                                        batch.fuel_consumption = fuelbatch?.fuel_consumption;
                                                                        batch.rob = lngBunker.quantity_remaining - (parseFloat(fuelbatch?.fuel_consumption));
                                                                    } else {
                                                                        batch.fuel_consumption = 0;
                                                                        batch.rob = lngBunker.quantity_remaining;
                                                                    }
                                                                } else if (index === 0) {
                                                                    if (lngBunker.quantity_remaining < fuelbatch?.fuel_consumption) {
                                                                        batch.fuel_consumption = lngBunker.quantity_remaining;
                                                                        batch.rob = 0;
                                                                        remainder = (parseFloat(fuelbatch?.fuel_consumption)) - lngBunker.quantity_remaining;
                                                                    }
                                                                } else if (index > 0) {
                                                                    if (lngBunker.quantity_remaining < remainder) {
                                                                        batch.fuel_consumption = lngBunker.quantity_remaining;
                                                                        batch.rob = 0;
                                                                        remainder -= lngBunker.quantity_remaining;
                                                                    } else {
                                                                        batch.fuel_consumption = remainder;
                                                                        batch.rob = lngBunker.quantity_remaining - remainder;
                                                                    }
                                                                }
                                                            }
                                                        });
                                                });
                                        }
                                    })
                            })
                            /** LNG cargo ROB update */
                            if (CurrentVessel?.vessel_type_precedence_id === VesselTypeConstant.LNG_CARRIER) {
                                values.lngCargoROB.cargo_consumed = loadArraySum(values?.fuelConsumption, "fuel_type_precedence_id", "fuel_consumed")[FuelTypes.LNG_CARGO];
                                if (checkValidObject(lngCargoROBPreviousReport)) {
                                    values.lngCargoROB.cargo_rob = parseFloat(lngCargoROBPreviousReport?.cargo_rob) ?? 0 -
                                        parseFloat(loadArraySum(values?.fuelConsumption, "fuel_type_precedence_id", "fuel_consumed")[FuelTypes.LNG_CARGO]) +
                                        parseFloat(cargoDetailsCurrentReport?.amount_of_cargo_loaded) -
                                        parseFloat(cargoDetailsCurrentReport?.amount_of_cargo_discharged) +
                                        parseFloat(cargoDetailsCurrentReport?.cargo_adjusted)
                                }
                                values.lngCargoROB.cargo_rob = checkForNaN(((checkValidObject(cargoDetailsCurrentReport) ?
                                    checkForNaN(cargoDetailsCurrentReport?.total_amount_of_cargo_onboard) :
                                    checkForNaN(lngCargoROBPreviousReport?.cargo_rob)) -
                                    checkForNaN(loadArraySum(values?.fuelConsumption, "fuel_type_precedence_id", "fuel_consumed")[FuelTypes.LNG_CARGO])
                                ), 4);
                                if (checkValidObject(lngCargoROBCurrentReport) && values.lngCargoROB.id > 0) {
                                    responseArray.push(apiGlobal.put(`/lng_cargo_rob/${values?.lngCargoROB?.id}/`, values?.lngCargoROB))
                                } else {
                                    responseArray.push(apiGlobal.post(`/lng_cargo_rob/`, values?.lngCargoROB))
                                }
                            }
                            /** Steam Dump Details submit */
                            if (isSteamDump) {
                                if (checkValidObject(steamDumpDetailsCurrentReport) && values?.steamDumpDetails?.id > 0) {
                                    responseArray.push(apiGlobal.put(`/steam_dump_details/${values?.steamDumpDetails?.id}/`, values?.steamDumpDetails));
                                } else {
                                    responseArray.push(apiGlobal.post(`/steam_dump_details/`, values?.steamDumpDetails));
                                }
                            }
                            await handleServerResponse(responseArray).then(async (res: any) => {
                                const promises = [];
                                if (res === true) {
                                    setEDNFiles([]);
                                    await dispatch(getCurrentReportAction(VesselID, ReportID));
                                    await dispatch(getCurrentReportFilesAction(ReportID, VesselID));
                                    if (currentVesselReport &&
                                        (currentVesselReport?.reporting_operation_mode === OperationPrecedence.ANCHOR_STAY ||
                                            currentVesselReport?.reporting_operation_mode === OperationPrecedence.PORT_STAY) &&
                                        addOtherPort && OtherPortsObject &&
                                        checkValidObject(OtherPortsObject?.find((port: any) =>
                                            port?.port_name === values?.shoreSupply?.other_port_name))) {
                                        promises.push(queryClient.invalidateQueries(queryKeyes.masters.OtherPortMaster.key));
                                    }
                                    await Promise.all(promises);
                                    if (env?.form_validation === true) {
                                        setErrorMessage(null);
                                        toggleDynamicTabs(previousEnggTabIndex + 1);
                                    }
                                } else if (Array.isArray(res)) {
                                    dispatch(getCurrentReportAction(VesselID, ReportID));
                                    if (currentVesselReport &&
                                        (currentVesselReport?.reporting_operation_mode === OperationPrecedence.ANCHOR_STAY ||
                                            currentVesselReport?.reporting_operation_mode === OperationPrecedence.PORT_STAY) &&
                                        addOtherPort && OtherPortsObject &&
                                        OtherPortsObject?.filter((port: any) =>
                                            port?.port_name === values?.bunkering[0]?.other_port_name)?.length === 0) {
                                        promises.push(queryClient.invalidateQueries(queryKeyes.masters.OtherPortMaster.key));
                                    }
                                }
                                setErrorMessage(res);
                                actions.setSubmitting(false);
                            }).finally(() => {
                                actions.setSubmitting(false);
                            });
                            setRefreshEDN((prev) => prev + 1);
                            setRefreshKey((prev) => prev + 1);
                        } catch {
                            actions.setSubmitting(false);
                        }
                    }}
                    initialValues={FuelConsumptionFormik.initialValues}
                    validationSchema={env?.form_validation === true ? FuelConsumptionFormik.validationSchema : null}
                >
                    {({ values, errors, handleSubmit, setErrors, isSubmitting, resetForm, setFieldTouched, validateForm }:
                        { values: any, errors: any, handleSubmit: any, handleChange: any, setErrors: any, handleBlur: any, touched: any, isSubmitting: any, validateForm: any, setFieldTouched: any, resetForm: any, isValid: any }) => (
                        <Form autoComplete="off" onSubmit={handleSubmit} noValidate>
                            <CardBody className='engineer-card-body'>
                                {/* {vesselMachineries?.filter((item: any) => (item.fuel_type_precedence_id === VesselMachineryConstant.EGCS ||
                                    item.fuel_type_precedence_id === VesselMachineryConstant.SCR ||
                                    item.fuel_type_precedence_id === VesselMachineryConstant.EGR
                                )).length > 0 &&
                                    <Row className='d-flex align-items-center p-2'>
                                        <Col sm={4}>
                                            {vesselMachineries?.filter((item: any) => item.fuel_type_precedence_id === VesselMachineryConstant.EGCS).length > 0 &&
                                                <div className="d-flex flex-wrap">
                                                    <Label className='mb-0' for='is_egcs_in_use'>
                                                        Is EGCS in use?<i className='bx bx-info-circle me-2' id='egcs_in_use_msg' />
                                                    </Label>
                                                    <ToolTip target='egcs_in_use_msg'
                                                        message={`${TooltipMsg.FuelConsumption
                                                            .filter((item: any) => item.target === 'egcs_in_use_msg')
                                                            .map((tool: any) => { return tool.message })}`}
                                                    />
                                                    <Field name={'scrubingUnit.is_egcs_in_use'}>
                                                        {({ field, form }: FieldProps) => (
                                                            <div className="square-switch sqswitch">
                                                                <Input
onFocus={(e) => e.target.select()}
                                                                    type="checkbox"
                                                                    switch="none"
                                                                    name={field.name}
                                                                    id='is_egcs_in_use'
                                                                    onChange={(e: any) => form.setFieldValue(field.name, e.target.checked)} />
                                                                <Label
                                                                    htmlFor={field.name}
                                                                    data-on-label='Yes'
                                                                    data-off-label='No'
                                                                    className='mb-0'
                                                                />
                                                            </div>
                                                        )}
                                                    </Field>
                                                    {errors?.scrubingUnit && errors?.scrubingUnit?.is_egcs_in_use && env?.form_validation === true &&
                                                        <ErrorTooltip
                                                            target={`is_egcs_in_use`}
                                                            message={errors?.scrubingUnit?.is_egcs_in_use}
                                                            open={(errors?.scrubingUnit && errors?.scrubingUnit?.is_egcs_in_use) && !adjustmentPopup ? true : false}
                                                        />
                                                    }
                                                </div>
                                            }
                                        </Col>
                                        <Col sm={4}>
                                            {vesselMachineries?.filter((item: any) => item.fuel_type_precedence_id === VesselMachineryConstant.SCR).length > 0 &&
                                                <div className="d-flex flex-wrap">
                                                    <Label className='mb-0' for='is_scr_in_use'>Is SCR in use?
                                                        <i className='bx bx-info-circle me-2' id='scr_in_use_msg' />
                                                    </Label>
                                                    <ToolTip target='scr_in_use_msg'
                                                        message={`${TooltipMsg.FuelConsumption
                                                            .filter((item: any) => item.target === 'scr_in_use_msg')
                                                            .map((tool: any) => { return tool.message })}`}
                                                    />
                                                    <Field name={'scrubingUnit.is_scr_in_use'}>
                                                        {({ field, form }: FieldProps) => (
                                                            <div className="square-switch sqswitch">
                                                                <Input
onFocus={(e) => e.target.select()}
                                                                    type="checkbox"
                                                                    switch="none"
                                                                    name={field.name}
                                                                    id='is_scr_in_use'
                                                                    onChange={(e: any) => form.setFieldValue(field.name, e.target.checked)} />
                                                                <Label
                                                                    htmlFor={field.name}
                                                                    data-on-label='Yes'
                                                                    data-off-label='No'
                                                                    className='mb-0'
                                                                />
                                                            </div>
                                                        )}
                                                    </Field>
                                                    {errors?.scrubingUnit && errors?.scrubingUnit?.is_scr_in_use && env?.form_validation === true &&
                                                        <ErrorTooltip
                                                            target={`is_scr_in_use`}
                                                            message={errors?.scrubingUnit?.is_scr_in_use}
                                                            open={(errors?.scrubingUnit && errors?.scrubingUnit?.is_scr_in_use) && !adjustmentPopup ? true : false}
                                                        />
                                                    }
                                                </div>
                                            }
                                        </Col>
                                        <Col sm={4}>
                                            {vesselMachineries?.filter((item: any) => item.fuel_type_precedence_id === VesselMachineryConstant.EGR).length > 0 &&
                                                <div className="d-flex flex-wrap">
                                                    <Label className='mb-0' for='is_egr_in_use'>
                                                        Is EGR in use?<i className='bx bx-info-circle me-2' id='egr_in_use_msg' />
                                                    </Label>
                                                    <ToolTip target='egr_in_use_msg'
                                                        message={`${TooltipMsg.FuelConsumption
                                                            .filter((item: any) => item.target === 'egr_in_use_msg')
                                                            .map((tool: any) => { return tool.message })}`}
                                                    />
                                                    <Field name={'scrubingUnit.is_egr_in_use'}>
                                                        {({ field, form }: FieldProps) => (
                                                            <div className="square-switch sqswitch">
                                                                <Input
onFocus={(e) => e.target.select()}
                                                                    type="checkbox"
                                                                    switch="none"
                                                                    name={field.name}
                                                                    id={'is_egr_in_use'}
                                                                    onChange={(e: any) => form.setFieldValue(field.name, e.target.checked)} />
                                                                <Label
                                                                    htmlFor={field.name}
                                                                    data-on-label='Yes'
                                                                    data-off-label='No'
                                                                    className='mb-0'
                                                                />
                                                            </div>
                                                        )}
                                                    </Field>
                                                    {errors?.scrubingUnit && errors?.scrubingUnit?.is_egr_in_use && env?.form_validation === true &&
                                                        <ErrorTooltip
                                                            target={`is_egr_in_use`}
                                                            message={errors?.scrubingUnit?.is_egr_in_use}
                                                            open={(errors?.scrubingUnit && errors?.scrubingUnit?.is_egr_in_use) && !adjustmentPopup ? true : false}
                                                        />
                                                    }
                                                </div>
                                            }
                                        </Col>
                                    </Row>
                                } */}
                                {((isSteamDump && !editReportBool) ||
                                    (editReportBool && checkValidObject(editInitialValues?.chief_engineer?.steam_dump_detail?.length > 0))) &&
                                    <SteamDumpDetailsComponent
                                        adjustmentPopup={adjustmentPopup}
                                        editValues={editValues}
                                        setEditValues={setEditValues}
                                    />
                                }
                                <ShoreSupplyComponent
                                    adjustmentPopup={adjustmentPopup}
                                    EDNFiles={EDNFiles}
                                    setEDNFiles={setEDNFiles}
                                    FileStatus={FileStatus}
                                    OtherPortsObject={OtherPortsObject}
                                    addOtherPort={addOtherPort}
                                    setAddOtherPort={setAddOtherPort}
                                    otherPort={otherPort}
                                    setOtherPort={setOtherPort}
                                    editValues={editValues}
                                    setEditValues={setEditValues}
                                    editReportBool={editReportBool}
                                    refreshEDN={refreshEDN}
                                    setRefreshEDN={setRefreshEDN}
                                    isShoreSupply={isShoreSupply}
                                    isSteamDump={isSteamDump}
                                />
                                <FuelConsumption
                                    adjustmentPopup={adjustmentPopup}
                                    machineryFuelGroup={machineryFuelGroup}
                                    fuelTypes={fuelTypes}
                                    setMeasurementMethod={setMeasurementMethod}
                                    measurementMethodOptions={measurementMethodOptions}
                                    Fuel_Consumption_inputs={Fuel_Consumption_inputs}
                                    setCount={setCount}
                                    setAlertColourType={setAlertColourType}
                                    setAlertType={setAlertType}
                                    machineryEnabled={machineryEnabled}
                                    count={count}
                                    editValues={editValues}
                                    setEditValues={setEditValues}
                                    vesselState={VesselState}
                                    isSteamDump={isSteamDump}
                                    isShoreSupply={isShoreSupply}
                                />
                                {/* <hr /> */}
                                {CurrentVessel?.vessel_type_precedence_id === VesselTypeConstant.LNG_CARRIER &&
                                    <LNGCargoROB
                                        AdditionalDetailsObject={AdditionalDetailsObject}
                                        count={count}
                                    />
                                }
                                <FuelConsumptionBatchComponent
                                    fuelTypes={fuelTypes}
                                    finalBatchConsumptionArray={finalBatchConsumptionArray}
                                    totalLNGBunkerROB={totalLNGBunkerROB}
                                    handleFuelBatchConsumptionChanges={handleFuelBatchConsumptionChanges}
                                    setFuelBatchIndex={setFuelBatchIndex}
                                    setAdjustmentPopup={setAdjustmentPopup}
                                    adjustmentPopup={adjustmentPopup}
                                    tog_backdrop={tog_backdrop}
                                    fuelBatchIndex={fuelBatchIndex}
                                    editValues={editValues}
                                    setEditValues={setEditValues}
                                    VesselState={VesselState}
                                    fuelBatchesFetching={fuelBatchesFetching}
                                    editReportBool={editReportBool}
                                />
                            </CardBody>
                            <CardFooter className="p-2 py-3">
                                <Row className="d-flex align-items-center flex-row-reverse">
                                    <Col lg={10}>
                                        <div className="d-flex flex-wrap gap-3 justify_right">
                                            {/* {editReportBool &&
                                                <Button
                                                    type="reset"
                                                    color="danger"
                                                    className="btn_size_cstm"
                                                    onClick={() => {
                                                        setEditValues({
                                                            ...editValues,
                                                            chief_engineer: {
                                                                ...editValues?.chief_engineer,
                                                                fuel_consumption: editInitialValues?.chief_engineer?.fuelConsumption,
                                                                fuel_consumption_batch: editInitialValues?.chief_engineer?.fuelConsumptionBatch,
                                                                shore_supply: editInitialValues?.chief_engineer?.shoreSupply,
                                                                steam_dump_details: editInitialValues?.chief_engineer?.steamDumpDetails,
                                                            }
                                                        })
                                                        setRefreshKey(refreshKey + 1);
                                                    }}
                                                >
                                                    Reset
                                                </Button>
                                            } */}
                                            <Button
                                                type={editReportBool ? "button" : "submit"}
                                                color="primary"
                                                className="btn_size_cstm"
                                                disabled={isSubmitting || editIsSubmitting}
                                                onClick={async () => {
                                                    // Run Formik validation manually (optional for edit mode)
                                                    const formErrors = await validateForm();

                                                    // Mark all fields as touched
                                                    Object.keys(values || {}).forEach((key: string) => {
                                                        if (Array.isArray(values[key])) {
                                                            values[key].forEach((_: any, index: number) => {
                                                                Object.keys(values[key][index]).forEach((nestedKey: string) => {
                                                                    setFieldTouched(`${key}[${index}].${nestedKey}`, true, false);
                                                                });
                                                            });
                                                        } else if (typeof values[key] === "object" && values[key] !== null) {
                                                            Object.keys(values[key]).forEach((nestedKey: string) => {
                                                                setFieldTouched(`${key}.${nestedKey}`, true, false);
                                                            });
                                                        } else {
                                                            setFieldTouched(key, true, false);
                                                        }
                                                    });

                                                    // Handle edit mode (no automatic submit)
                                                    if (editReportBool && Object.keys(formErrors || {}).length === 0) {
                                                        await saveEditForm(editSubmit, toggleDynamicTabs, previousEnggTabIndex, setPreviousTabIndex);
                                                        setRefreshKey(refreshKey + 1);
                                                    }

                                                    // Always refresh report files after submit or edit
                                                    dispatch(getCurrentReportFilesAction(ReportID, VesselID));
                                                }}
                                            >
                                                {(isSubmitting || editIsSubmitting) && (
                                                    <i className="ms-2 spinner-border spinner-border-sm text-light me-2" />
                                                )}
                                                Next <i className="bx bx-chevron-right ms-1" />
                                            </Button>
                                        </div>
                                    </Col>
                                    <Col lg={2}>
                                        <Button
                                            type="button"
                                            color="primary"
                                            className="btn_size_cstm"
                                            onClick={() => {
                                                setErrorMessage(null);
                                                setErrors({});
                                                resetForm();
                                                toggleDynamicTabs(previousEnggTabIndex - 1);
                                            }}
                                        >
                                            <i className="bx bx-chevron-left me-1" /> Previous
                                        </Button>
                                    </Col>
                                </Row>
                            </CardFooter>
                            {alertBool &&
                                <AlertPopup
                                    state={alertBool}
                                    setState={setAlertBool}
                                    alertMessage={alertMessage}
                                    setAlertMessage={setAlertMessage}
                                    AlertColourType={alertColourType}
                                    setAlertColourType={setAlertColourType}
                                    alertType={alertType}
                                    setAlertType={setAlertType}
                                    formTitle="Weather Data"
                                    continueSubmit={true}
                                />
                            }
                            <FormValuesDebug values={[values, errors, FuelConsumptionFormik.initialValues]} />
                        </Form>
                    )}
                </Formik >
            }
        </Card >
    )
}

export default FuelConsumptionComponent;
